import React, { Component } from "react";
import { Button, Tooltip, Icon, Select } from "antd";
import { library } from "@fortawesome/fontawesome-svg-core";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { devMode } from "./Settings";
import { DownloadButton, downloadAd } from "./Helpers";
import {
  faPlusCircle,
  faMinusCircle,
  faExpandArrowsAlt,
  faExpand,
  faStickyNote,
  faSquare,
  faHighlighter,
  faStop,
  faVectorSquare
} from "@fortawesome/free-solid-svg-icons";
library.add(faPlusCircle);
library.add(faMinusCircle);
library.add(faExpandArrowsAlt);
library.add(faExpand);
library.add(faStickyNote);
library.add(faSquare);
library.add(faHighlighter);
library.add(faStop);
library.add(faVectorSquare);

const ButtonGroup = Button.Group;
const Option = Select.Option;

class ReportHeader extends Component {
  constructor(props) {
    super(props);
    this.state = {
      adType: null,
      buttons: [],
      loadConfig: this.props.loadConfig,
      muted: true,
      noteMode: true,
      sidebarVisible: true,
      toggleTooltip: this.props.translations.collapse,
      toggleView: "menu-fold",
      value: null,
      zoom: 1,
      pageCount: 0
    };
    this.onChange = this.onChange.bind(this);
  }

  handleMaterialSelect = value => {
    console.log("value", value);
    const { currentMaterials } = this.props;
    setTimeout(() => {
      currentMaterials.map(material => {
        if (material.id === value) {
          this.props.previewClick(
            true,
            material.id,
            material.materialSpecificationId,
            "[]",
            material.productionad,
            material.status.code,
            false
          );
        }
      });
    }, 300);
  };
  onChange(checked) {
    console.log(`switch to ${checked}`);
    this.props.switchView(checked);
    if (checked) {
      document.getElementById("videoControls").classList.remove("d-none");
    } else {
      document.getElementById("videoControls").classList.add("d-none");
    }
  }
  handleToggle() {
    console.log("toggling sidebar");
    const sidebarVisible = this.state.sidebarVisible;
    const { translations } = this.props;
    if (sidebarVisible) {
      this.setState({
        sidebarVisible: false,
        toggleView: "menu-unfold",
        toggleTooltip: translations.expand
      });
    } else {
      this.setState({
        sidebarVisible: true,
        toggleView: "menu-fold",
        toggleTooltip: translations.collapse
      });
    }
    this.props.sidebarVisible(sidebarVisible);
  }
  handleZoomIn() {
    console.log("Zooming in");
    let zoom = this.props.zoom;
    if (zoom < 2) {
      this.setState({ zoom: zoom / 0.75 });
      this.props.handleZoomIn(zoom / 0.75);
    }
    //this.noteMode(false);
  }
  handleZoomOut() {
    console.log("Zooming out");
    let zoom = this.props.zoom;
    if (true || zoom > 0.25) {
      this.setState({ zoom: zoom * 0.75 });
      this.props.handleZoomOut(zoom * 0.75);
    }
    //this.noteMode(false);
  }
  handleFitIn() {
    console.log("Fitting in");
    this.props.handleFitIn();
    const defaultZoom = this.props.defaultZoom;
    this.setState({ zoom: defaultZoom });
    //this.noteMode(false);
  }
  handleRealSize() {
    console.log("Real size in");
    this.setState({ zoom: 1 });
    this.props.handleRealSize();
    //this.noteMode(false);
  }

  noteMode = visible => {
    const annotationCanvas = document.getElementById("annotationCanvas");
    if (annotationCanvas && visible) annotationCanvas.classList.add("visible");
    if (annotationCanvas && !visible)
      annotationCanvas.classList.remove("visible");
  };

  handleAnnotation = type => {
    const annotationForm = document.getElementById('annotationForm')
    if (annotationForm && annotationForm.getAttribute("data-visible") === "true") {
      const closeAnnotation = document.getElementById('closeAnnotation')
      const deleteAnnotationButton = document.getElementById('deleteAnnotationButton')
      if (closeAnnotation.hasAttribute('disabled')) deleteAnnotationButton.click()
      else closeAnnotation.click()

    }
    const annotationCanvas = document.getElementById("annotationCanvas");
    this.setState({ noteMode: true });
    if (annotationCanvas) annotationCanvas.classList.add("visible");
    else console.error("No annotationCanvas");
    this.props.handleAnnotation(type);
    if (!devMode)
      setTimeout(function () {
        if (document.getElementById("annotationTab"))
          document.getElementById("annotationTab").click();
      }, 100);
  };
  handleView() {
    const annotationCanvas = document.getElementById("annotationCanvas");

    this.setState({ noteMode: false });
    if (annotationCanvas) annotationCanvas.classList.remove("visible");
    else console.error("No annotationCanvas");
  }
  pauseAd = () => {
    const videoFrame = document.getElementById("videoFrame");
    videoFrame.pause();
  };

  playAd = () => {
    const ReportPreviewContainer = document.getElementById(
      "ReportPreviewContainer"
    );
    const videoFrame = document.getElementById("videoFrame");
    ReportPreviewContainer.classList.remove("animation-false");
    ReportPreviewContainer.classList.add("animation-true");
    if (videoFrame) videoFrame.play();
    /*else
        setTimeout(function(){
            //document.getElementById('video-play').classList.add('d-none');
            document.getElementById('video-stop').classList.remove('d-none');
            document.getElementById('video-stop').classList.add('d-inline-block');
        } , 500)*/
    const iFrameID = document.getElementById("previewFrame");
    if (iFrameID) {
      iFrameID.style.visibility = "hidden";
      iFrameID.src = iFrameID.src;
    }
    this.props.handleFrameStyles;
    this.props.playInnerAd;
    //this.handleRealSize()
  };
  stopAd = () => {
    const ReportPreviewContainer = document.getElementById(
      "ReportPreviewContainer"
    );
    const videoFrame = document.getElementById("videoFrame");
    const previewFrame = document.getElementById("previewFrame");
    if (previewFrame) {
      previewFrame.src = previewFrame.src;
    }
    ReportPreviewContainer.classList.add("animation-false");
    ReportPreviewContainer.classList.remove("animation-true");
    if (videoFrame) {
      videoFrame.pause();
      videoFrame.currentTime = 0;
    } /*else{
            setTimeout(function(){
                document.getElementById('video-play').classList.remove('d-none');
                document.getElementById('video-stop').classList.remove('d-block');
                document.getElementById('video-stop').classList.add('d-none');
            } , 500);
        }*/
    //if(videoFrame)videoFrame.pause();
  };
  soundVideo = (e, muted) => {
    console.log(!muted);
    e.target.setAttribute("data-muted", !muted);
    const videoFrame = document.getElementById("videoFrame");
    videoFrame.muted = !muted;
    this.setState({ muted: !muted });
  };
  muteVideo = () => { };
  showVisual = () => {
    this.props.checkAnnotations("material", false);
    this.props.previewClick(
      true,
      this.props.approveAdmaterialId,
      this.props.specId,
      "[]",
      true,
      null,
      true
    );
    /*
        if(this.props.newAnnotations.length > 0){
              Modal.error({
                title: this.props.translations.forbidden,
                content: this.props.translations.unsubmittedAnnotations,
                onOk: () => console.log('back to details'),
                onCancel: () => console.log('back to details')
              });
            return;
        }else{
            this.props.previewClick(true , this.props.approveAdmaterialId , this.props.specId , '[]' , true , null , true)
        }
        */
  };
  showMaterial = () => {
    this.props.checkAnnotations("asset", false);
    this.props.previewClick(
      true,
      this.props.approveAdmaterialId,
      this.props.specId,
      "[]",
      true,
      null,
      false
    );
    /*
        if(this.props.newAnnotations.length > 0){
              Modal.error({
                title: this.props.translations.forbidden,
                content: this.props.translations.unsubmittedAnnotations,
                onOk: () => console.log('back to details'),
                onCancel: () => console.log('back to details')
              });
            return;
        }else{
            this.props.previewClick(true , this.props.approveAdmaterialId , this.props.specId , '[]' , true , null , false);
        }
        */
  };
  prevPage = e => {
    let pageCount = this.state.pageCount;
    pageCount = pageCount - 1;
    this.setState({ pageCount: pageCount });
    this.props.showPrevPage(pageCount);
    //console.log(pageCount);
  };
  nextPage = e => {
    let pageCount = this.state.pageCount;
    pageCount = pageCount + 1;
    this.setState({ pageCount: pageCount });
    this.props.showNextPage(pageCount);
    //console.log(pageCount);
  };
  render() {
    const {
      currentMaterials,
      approveAdmaterialId,
      translations,
      hasMaterial,
      allowDownload
    } = this.props;
    return (
      <header className="report-header">
        <div className="report-title d-none">
          <strong>Order number: </strong>
        </div>
        <div className="button-group">
          <Tooltip
            placement="bottom"
            mouseEnterDelay={0.5}
            title={this.state.toggleTooltip}
          >
            <Button
              type="default"
              shape="circle"
              icon={this.state.toggleView}
              onClick={() => this.handleToggle()}
            />
          </Tooltip>
          <Tooltip
            placement="bottom"
            mouseEnterDelay={0.5}
            title={translations.zoomIn}
          >
            <Button
              data-translationkey="zoomIn"
              id="zoomInButton"
              type="default"
              onClick={() => this.handleZoomIn()}
            >
              <FontAwesomeIcon icon="plus-circle" />
            </Button>
          </Tooltip>
          <Tooltip
            placement="bottom"
            mouseEnterDelay={0.5}
            title={translations.zoomOut}
          >
            <Button
              id="zoomOutButton"
              type="default"
              data-translationkey="zoomOut"
              onClick={() => this.handleZoomOut()}
            >
              <FontAwesomeIcon icon="minus-circle" />
            </Button>
          </Tooltip>
          <Tooltip
            placement="bottom"
            mouseEnterDelay={0.5}
            title={translations.fit}
          >
            <Button
              type="default"
              data-translationkey="fit"
              onClick={() => this.handleFitIn()}
            >
              <FontAwesomeIcon icon="expand-arrows-alt" />
            </Button>
          </Tooltip>
          <Tooltip
            placement="bottom"
            mouseEnterDelay={0.5}
            title={translations.adSize}
          >
            <Button
              data-translationkey="adSize"
              id="adSizeButton"
              type="default"
              onClick={() => this.handleRealSize()}
            >
              <FontAwesomeIcon icon="expand" />
            </Button>
          </Tooltip>
        </div>
        <ButtonGroup>
          <Tooltip title={translations.previousPage}>
            <Button
              type="default"
              disabled={this.props.pageCount < 1 || !this.props.pageCountMax}
              onClick={e => this.prevPage(e)}
              data-page={this.props.pageCount}
              icon="caret-left"
              data-translationkey="previousPage"
            />
          </Tooltip>

          {this.props.pageCountMax > 1 && (
            <span style={{ margin: "0 5px" }}>{this.props.pageCount + 1}</span>
          )}
          <Tooltip title={translations.nextPage}>
            <Button
              type="default"
              disabled={
                this.props.pageCount > this.props.pageCountMax - 2 ||
                !this.props.pageCountMax
              }
              onClick={e => this.nextPage(e)}
              data-page={this.props.pageCount}
              icon="caret-right"
              data-translationkey="nextPage"
            />
          </Tooltip>
        </ButtonGroup>
        {this.props.editableView &&
          (devMode || this.props.canCreateAnnotation) && (
            <div id="annotationTools" className="button-group">
              <Tooltip
                placement="bottom"
                mouseEnterDelay={0.5}
                title={translations.stickyNote}
              >
                <Button
                  data-translationkey="stickyNote"
                  id="sticker-button"
                  type="default"
                  onClick={() => this.handleAnnotation("STICKER")}
                >
                  <FontAwesomeIcon icon="sticky-note" />
                </Button>
              </Tooltip>
              <Tooltip
                placement="bottom"
                mouseEnterDelay={0.5}
                title={translations.frameNote}
              >
                <Button
                  id="frame-button"
                  type="default"
                  onClick={() => this.handleAnnotation("FRAME")}
                  data-translationkey="frameNote"
                >
                  <FontAwesomeIcon icon="vector-square" />
                </Button>
              </Tooltip>
              <Tooltip
                placement="bottom"
                mouseEnterDelay={0.5}
                title={translations.highlighter}
              >
                <Button
                  id="marker-button"
                  type="default"
                  onClick={() => this.handleAnnotation("HIGHLIGHT")}
                  data-translationkey="highlighter"
                >
                  <FontAwesomeIcon icon="highlighter" />
                </Button>
              </Tooltip>
            </div>
          )}
        {hasMaterial && allowDownload && (
          <Tooltip placement="bottom" title={translations.download}>
            <DownloadButton
              onClick={e => downloadAd(approveAdmaterialId, e)}
              type="cloud-download"
              text={translations.download}
              langkey="download"
            />
          </Tooltip>
        )}
        {(true || this.props.proofLink) && (
          <a
            id="proofLinkAnchor"
            className={this.props.proofLink ? "proof-link" : "d-none"}
            href={this.props.proofLink}
            target="_blank"
          >
            <Icon type="link" />{" "}
            {this.props.translations.proofLink
              ? this.props.translations.proofLink
              : "Preview on website"}
          </a>
        )}
        {/*MATERIAL NAVIGATION */ false && (
          <Select
            defaultValue={approveAdmaterialId}
            style={{ width: 120 }}
            name="materialsReportSelect"
            onChange={this.handleMaterialSelect}
          >
            {currentMaterials.map((material, index) => (
              <Option value={material.id}>AD {material.id}</Option>
            ))}
          </Select>
        )}
        {this.props.showVideoControls && this.props.loadIframe && (
          <div id="animation-switch" className="animation-switch">
            <ButtonGroup id="videoControls" size="small">
              <Tooltip placement="bottom" title={translations.playAd}>
                <Button
                  className="animation-button"
                  id="video-play"
                  type="secondary"
                  onClick={() => this.playAd()}
                >
                  <span className="" data-translation="playAd">
                    {this.props.translations.playAd}
                  </span>
                  <Icon className="margin-left-0" type="play-circle" />
                </Button>
              </Tooltip>
              <Tooltip placement="bottom" title={translations.pauseAd}>
                <Button
                  className="video-control animation-button"
                  type="secondary"
                  icon="pause-circle"
                  onClick={() => this.pauseAd()}
                />
              </Tooltip>
              <Tooltip placement="bottom" title={translations.stopAd}>
                <Button
                  id="video-stop"
                  className="animation-button"
                  type="secondary"
                  onClick={() => this.stopAd()}
                >
                  <span data-translation="stopAd">
                    {this.props.translations.stopAd}
                  </span>
                  <FontAwesomeIcon icon="stop" />
                </Button>
              </Tooltip>
              <Tooltip placement="bottom" title={translations.sound}>
                <Button
                  id="soundButtonControl"
                  data-muted={this.state.muted}
                  className={this.state.muted}
                  type="secondary"
                  icon="notification"
                  onClick={e => this.soundVideo(e, this.state.muted)}
                />
              </Tooltip>
            </ButtonGroup>
          </div>
        )}
        {this.props.hasVisual &&
          !this.props.assetView &&
          this.props.productionad && (
            <Button
              translationKey="showVisual"
              className="toggle-visual-button d-none"
              onClick={() => this.showVisual()}
              size="small"
              id="ad-show-visual"
              key="ad-show-visual"
              type="secondary"
            >
              {this.props.translations.showVisual}
            </Button>
          )}
        {this.props.productionad && this.props.hasMaterial && (
          <Button
            translationKey="showMaterial"
            className="toggle-visual-button d-none"
            onClick={() => this.showMaterial()}
            size="small"
            id="ad-show-material"
            key="ad-show-material"
            type="secondary"
          >
            {this.props.translations.showMaterial}
          </Button>
        )}
        {true && (
          <span>
            <Button
              translationKey="deleteVisual"
              onClick={() =>
                this.props.deleteVisual(
                  this.props.approveAdmaterialId,
                  this.props.specId,
                  this.props.assetVisualId
                )
              }
              size="small"
              id="ad-delete-visual"
              key="ad-delete-visual"
              type="secondary"
              className="d-none"
              style={{ color: 'tomato' }}
            >
              {this.props.translations.deleteVisual}
            </Button>
          </span>
        )}
      </header>
    );
  }
  componentDidMount() { }
  componentWillUpdate(nextProps) {
    const deleteVisual = document.getElementById("ad-delete-visual");
    const showVisual = document.getElementById("ad-show-visual");
    if (
      (this.props.hasVisual && !this.props.assetView) ||
      !this.props.assetView
    ) {
      if (showVisual) showVisual.classList.remove("d-none");
      if (deleteVisual) deleteVisual.classList.add("d-none");
    } else {
      if (showVisual) showVisual.classList.add("d-none");
      if (deleteVisual && this.props.canCreateAssetVisual) deleteVisual.classList.remove("d-none");
    }
    const showMaterial = document.getElementById("ad-show-material");
    if (this.props.assetView && this.props.hasMaterial) {
      if (showMaterial) showMaterial.classList.remove("d-none");
    } else {
      if (showMaterial) showMaterial.classList.add("d-none");
    }
    /*if (
      devMode ||
      (this.props.canDeleteAsset &&
        this.props.editableView &&
        this.props.statusCode != 518 &&
        this.props.assetView &&
        this.props.hasVisual &&
        this.props.canCreateAnnotation)
    ) {
      if (this.props.assetView && this.props.hasMaterial) {
        if (deleteVisual) deleteVisual.classList.remove("d-none");
      }
    }*/
    //console.log("Mounted ReportHeader...", this.props.canCreateAnnotation);
    /*if (this.props.disabledStickyNote) {
        const elem = document.getElementById("sticker-button");
        if (elem) elem.setAttribute("disabled", "disabled");
        else console.log("sticker-button not found");
      } else {
        const elem = document.getElementById("sticker-button");
        if (elem) elem.removeAttribute("disabled");
      }*/
    if (this.props.approveAdmaterialId !== nextProps.approveAdmaterialId) {
      this.setState({
        pageCount: this.props.pageCount,
        pageCountMax: this.props.pageCountMax,
        played: false
      });
      console.log(
        "Reportheader current materials",
        this.props.currentMaterials
      );
    }
  }

  shouldComponentUpdate(nextProps, nextState) {
    if (this.props !== nextProps) {
      return true;
    }
    if (this.state.played === nextState.played) return false;
    if (this.state.muted !== nextState.muted) return true;
    return false;
  }

  componentDidUpdate() {
    const that = this;
    if (
      !this.state.played &&
      this.props.showVideoControls &&
      this.props.loadConfig &&
      this.props.loadIframe &&
      this.props.loadConfig["web.details.autoplay"]
    ) {
      this.setState({ played: true });
      setTimeout(function () {
        that.playAd();
      }, 250);
    }
  }
}

export default ReportHeader;



// WEBPACK FOOTER //
// ./src/components/ReportHeader.js